<template>
  <div class="manual-wrapper">
    <div class="left-tree">
      <div class="title">使用指南</div>
      <el-tree
        class="tree-manual"
        :data="manualTree.children"
        :props="defaultProps"
        node-key="id"
        @node-click="deptNodeClick"
        highlight-current
        accordion
        ref="tree"
      ></el-tree>
    </div>
    <div class="right-container">
      <div v-html="contentDetails" ref="renderArea" class="content-details-render"></div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import './manual.scss';
</style>
<script>
import { contentMap } from './content'
export default {
  name: 'manual',
  data() {
    return {
      manualTree: {
        label: '',
        id: 0,
        children: [
          {
            label: '公司简介',
            relevance: 'companyIntro',
            id: 1,
            children: []
          },
          {
            label: '产品介绍',
            relevance: 'productionIntro',
            id: 2,
            children: []
          },
          {
            label: '注册',
            relevance: 'register',
            id: 3,
            children: []
          },
          {
            label: '登录',
            relevance: 'login',
            id: 4,
            children: []
          },
          {
            label: '立即翻译',
            relevance: 'translate',
            id: 5,
            children: []
          },
          {
            label: '我的任务',
            relevance: 'myTask',
            id: 6,
            children: [
              {
                label: '翻译预览',
                relevance: 'myTask-overview',
                id: 8,
                children: []
              },
              {
                label: '翻译下载',
                relevance: 'myTask-download',
                id: 9,
                children: [
                  {
                    label: '单独下载',
                    relevance: 'myTask-download-single',
                    id: 15,
                    children: []
                  },
                  {
                    label: '批量下载',
                    relevance: 'myTask-download-batch',
                    id: 16,
                    children: []
                  }
                ]
              }
            ]
          },
          {
            label: '术语库',
            id: 7,
            relevance: 'termLibrary',
            children: [
              {
                label: '新建词表',
                id: 10,
                relevance: 'termLibrary-creat-vocabulary',
                children: []
              },
              {
                label: '更新词表',
                id: 11,
                relevance: 'termLibrary-update-vocabulary',
                children: []
              },
              {
                label: '修改词表',
                id: 12,
                relevance: 'termLibrary-modify-vocabulary',
                children: [
                  {
                    label: '添加词条',
                    id: 17,
                    relevance: 'termLibrary-modify-vocabulary-add',
                    children: []
                  },
                  {
                    label: '修改词条',
                    id: 18,
                    relevance: 'termLibrary-modify-vocabulary-modify',
                    children: []
                  },
                  {
                    label: '删除词条',
                    id: 19,
                    relevance: 'termLibrary-modify-vocabulary-delete',
                    children: []
                  }
                ]
              },
              {
                label: '删除词表',
                id: 13,
                relevance: 'termLibrary-delete-vocabulary',
                children: [
                  {
                    label: '单独删除',
                    id: 20,
                    relevance: 'termLibrary-delete-vocabulary-single',
                    children: []
                  },
                  {
                    label: '批量删除',
                    id: 21,
                    relevance: 'termLibrary-delete-vocabulary-batch',
                    children: []
                  }
                ]
              },
              {
                label: '下载词表',
                id: 14,
                relevance: 'termLibrary-download-vocabulary',
                children: [
                  {
                    label: '单独下载',
                    id: 22,
                    relevance: 'termLibrary-download-vocabulary-single',
                    children: []
                  },
                  {
                    label: '批量下载',
                    id: 23,
                    relevance: 'termLibrary-download-vocabulary-batch',
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      contentDetails: ''
    }
  },
  methods: {
    dfs(root) {
      // 深度遍历树中各节点
      if (root && root.$children) {
        root.$children.forEach(child => {
          child.node.isCurrent = false
          this.dfs(child)
        })
      }
    },

    deptNodeClick(item, e) {
      this.dfs(this.$refs.tree) // 深度遍历节点。清空其他父子关联节点的当选状态
      this.contentDetails = ''
      let parentContent = ''
      let GrandParentContent = ''
      let self = contentMap.get(item.relevance)
      let coreKey = ''

      // 点击相应的节点页面平滑滚动到相应的锚位
      let renderAreaNodeList = this.$refs.renderArea.children
      let currentScrollToAnchor = null
      renderAreaNodeList.forEach(node => {
        if (node.id == item.relevance) {
          currentScrollToAnchor = node
        }
      })
      if (currentScrollToAnchor) {
        let topOfElement = currentScrollToAnchor.offsetTop - 70
        window.scroll({ top: topOfElement, behavior: 'smooth' })
      }

      e.isCurrent = true
      // 点击当前项，其（祖）父节点高度关联，表现为都背景选中
      // 其他项，会去掉高度关联状态，表现为其他子树都去掉选中状态
      if (item.relevance.includes('-')) {
        // 多层级
        coreKey = item.relevance.split('-')[0]

        this.renderWrapper(item.id, item.label, contentMap.get(coreKey))
      } else {
        if (e.parent.data.label) {
          parentContent = contentMap.get(e.parent.data.relevance)
          // 有父节点
          if (e.parent.nextSibling) {
            e.parent.nextSibling.isCurrent = false
          }
          if (e.parent.previousSibling) {
            e.parent.previousSibling.isCurrent = false
          }
          e.parent.isCurrent = true
          if (e.parent.parent.data.label) {
            GrandParentContent = contentMap.get(e.parent.parent.data.relevance)
            // 有祖父节点
            if (e.parent.parent.nextSibling) {
              e.parent.parent.nextSibling.isCurrent = false
            }
            if (e.parent.parent.previousSibling) {
              e.parent.parent.previousSibling.isCurrent = false
            }
            e.parent.parent.isCurrent = true
          }
        }
        this.contentDetails = `${GrandParentContent}${parentContent}${self}`
        this.renderWrapper(item.id, item.label, this.contentDetails)
      }
    },
    renderWrapper(id, label, content) {
      this.contentDetails = content
    }
  },
  created() {
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(1)
      this.renderWrapper(1, '公司简介', contentMap.get('companyIntro'))
    })
  }
}
</script>

<style lang="scss">
.el-tree-node__label {
  font-size: 14px;
  font-weight: 600;
  color: #5e6066;
  text-indent: 16px;
}
.el-tree-node {
  width: 160px;
}
.el-tree-node__content {
  width: 160px;
  height: 36px;
  margin-bottom: 8px;
}
.el-tree-node__expand-icon {
  position: absolute;
  right: 30px;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  height: 36px;
  background: #eef2ff;
  border-radius: 4px;
  .el-tree-node__label {
    color: #2962ff;
  }
}
div[role='group'] {
  div[role='treeitem'] {
    .el-tree-node__content {
      .el-tree-node__label {
        font-weight: 400;
        color: #909299;
        text-indent: 0;
      }
    }
  }
}
.el-tree-node__expand-icon {
  transform: rotate(90deg);
}
.el-tree-node__expand-icon.expanded {
  color: #2962ff;
  transform: rotate(-90deg);
}
</style>
